import "../node_modules/swing-ui/dist/css/swing.min.css";
import "./assets/less/main.less";

import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App.jsx";
import { FormFlowProvider } from "./components/forms/FormFlowProvider.jsx";
import appSettings from "./settings/appSettings";

const { app_root_id = "bettermode-app" } = appSettings;

ReactDOM.createRoot(document.getElementById(app_root_id)).render(
  <React.StrictMode>
    <FormFlowProvider>
      <App />
    </FormFlowProvider>
  </React.StrictMode>
);
